module.exports = __webpack_public_path__ + "static/origens-slide_r-9a2918adcc56395a052371facd08d44a.jpg";